import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomDialog from "../../UI/Dialog/CustomDialog";
import { resetRiepilogoDelete } from "../../../redux/reducers/riepilogoDelete-reducer";
import { BodyRiepilogoDelete } from "./BodyRiepilogoDelete/BodyRiepilogoDelete";

const DialogRiepilogoAfterDelete = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const riepilogoDeleteData = useSelector((state) => state.riepilogoDelete);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(riepilogoDeleteData && Object.keys(riepilogoDeleteData).length > 0);
  }, [riepilogoDeleteData]);

  const handleClose = () => {
    setIsOpen(false);
    dispatch(resetRiepilogoDelete());
  };

  return (
    <CustomDialog
      title={t("delete_summary")}
      body={<BodyRiepilogoDelete data={riepilogoDeleteData} />}
      handleClose={handleClose}
      open={isOpen}
    />
  );
};

export default DialogRiepilogoAfterDelete;